export const PRODUCT_NAME = "МТС LocationPro";
export const EMAIL_SUPPORT = "locationpro@mts.ru";
export const PHONE_SUPPORT = "88002500990";
export const PHONE_SUPPORT_MAPPED = "8 800 250-09-90";
